// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-table {
  height: fit-content;
  margin-top: 4rem;
  margin-bottom: 3rem;
}
.wallet-table__title {
  font-size: 1.25rem;
  font-weight: 800;
  margin-bottom: 1rem;
  text-align: start;
}
.wallet-table__disclaimer {
  margin-top: 1rem;
  text-align: start;
  font-size: 0.75rem;
}
.wallet-table__buttons {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.wallet-table__buttons__button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4BABB9;
  color: white;
  width: 16rem;
  height: 2rem;
  border-radius: 0.8rem;
  cursor: pointer;
}
.wallet-table__content .achat-vente-table {
  overflow-x: auto;
}
.wallet-table__content table {
  border-collapse: collapse;
  width: 100%;
  font-size: 0.75rem;
}
.wallet-table__content th,
.wallet-table__content td {
  border: 0.0625rem solid #ddd;
  padding: 0.57rem;
  text-align: left;
  width: fit-content;
  text-wrap: wrap;
  height: 2rem;
}
.wallet-table__content th:last-child,
.wallet-table__content td:last-child {
  text-wrap: wrap;
}
.wallet-table__content th:not(:first-child) {
  background-color: #4babb9;
  color: white;
}
.wallet-table__content .asset {
  font-weight: bold;
  color: white;
}
.wallet-table__content .bold {
  font-weight: bold;
  color: black;
}
.wallet-table__content a {
  color: black;
}
.wallet-table__content .action {
  background-color: #4babb9;
}
.wallet-table__content .obligations {
  background-color: #ef936c;
}
.wallet-table__content .monetaire {
  background-color: #031280;
}
.wallet-table__content .diversifie {
  background-color: #d0cece;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/wallet-table/wallet-table.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,gBAAA;EACA,mBAAA;AACD;AAAC;EACG,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAEJ;AAAE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AAEJ;AAAI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAEN;AAEM;EACI,gBAAA;AAAV;AAGQ;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;AADV;AAIQ;;EAEE,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAFV;AAGU;;EACE,eAAA;AAAZ;AAKQ;EACE,yBAAA;EACA,YAAA;AAHV;AAKQ;EACE,iBAAA;EACA,YAAA;AAHV;AAKQ;EACE,iBAAA;EACA,YAAA;AAHV;AAMQ;EACE,YAAA;AAJV;AAMQ;EACA,yBAAA;AAJR;AAMQ;EACA,yBAAA;AAJR;AAMQ;EACA,yBAAA;AAJR;AAMQ;EACE,yBAAA;AAJV","sourcesContent":[".wallet-table{\n height: fit-content;\n margin-top: 4rem;\n margin-bottom: 3rem;\n &__title{\n    font-size: 1.25rem;\n    font-weight: 800;\n    margin-bottom: 1rem;\n    text-align: start;\n  }\n  &__disclaimer{\n    margin-top: 1rem;\n    text-align: start;\n    font-size: 0.75rem;\n}\n  &__buttons{\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n    margin-bottom: 1rem;\n\n    &__button{\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #4BABB9;\n      color: white;\n      width: 16rem;\n      height: 2rem;\n      border-radius: 0.8rem;\n      cursor: pointer;\n  }\n  }\n  &__content{\n      .achat-vente-table {\n          overflow-x: auto;\n        }\n        \n        table {\n          border-collapse: collapse;\n          width: 100%;\n          font-size: 0.75rem;\n        }\n        \n        th,\n        td {\n          border: 0.0625rem solid #ddd;\n          padding: 0.57rem;\n          text-align: left;\n          width: fit-content;\n          text-wrap: wrap;\n          height: 2rem;\n          &:last-child {\n            text-wrap: wrap;\n          }\n          \n        }\n\n        th:not(:first-child) {\n          background-color: #4babb9;\n          color: white;\n        }\n        .asset{\n          font-weight: bold;\n          color: white;\n        }\n        .bold {\n          font-weight: bold;\n          color:black;\n         \n        }\n        a{\n          color: black;\n        }\n        .action{\n        background-color: #4babb9;\n        }\n        .obligations{\n        background-color: #ef936c;\n        }\n        .monetaire{\n        background-color: #031280;\n        }\n        .diversifie{\n          background-color: #d0cece;\n        }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
